import { render, staticRenderFns } from "./MealPlanCollectionListView.vue?vue&type=template&id=524aa58b&scoped=true"
import script from "./MealPlanCollectionListView.vue?vue&type=script&lang=js"
export * from "./MealPlanCollectionListView.vue?vue&type=script&lang=js"
import style0 from "./MealPlanCollectionListView.vue?vue&type=style&index=0&id=524aa58b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524aa58b",
  null
  
)

export default component.exports